var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.666,
    height: 8,
    viewBox: "0 0 10.666 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.453.178a.667.667,0,0,1,.036.942l-6,6.482a1.22,1.22,0,0,1-1.8,0L.178,4.9a.667.667,0,0,1,.978-.906L3.583,6.613,9.511.214A.667.667,0,0,1,10.453.178Z",
    fill: "#696969",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleTick);
export default __webpack_public_path__ + "static/media/single_tick.dc96d72e1e3fc4176c61286b416145c2.svg";
export { ForwardRef as ReactComponent };